import { apiPath } from '../../constants';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';
import download from 'downloadjs';

/**
 * «Звіт головної суддівської колегії». The backend owns the fields — which
 * exist, their labels, what the competition's data says for each
 * (ChiefJudgeReportBuilder) — so the form renders what it is given.
 *
 * Both resolve the field list, or null when the request failed (the error is
 * reported).
 */
/*
 * `report`: 'chiefJudge' (default) or 'ministry' — the «Оперативний звіт» for
 * the Ministry of Youth and Sports, the same store with its own fields
 * (10 Oct 2026).
 */
const PATHS = {
    chiefJudge: ['COMPETITION_CHIEF_JUDGE_REPORT', 'COMPETITION_CHIEF_JUDGE_REPORT_SAVE', 'COMPETITION_CHIEF_JUDGE_REPORT_DOCX'],
    ministry: ['COMPETITION_MINISTRY_REPORT', 'COMPETITION_MINISTRY_REPORT_SAVE', 'COMPETITION_MINISTRY_REPORT_DOCX'],
};
const pathOf = (report, index) => apiPath.REPORTS[(PATHS[report] || PATHS.chiefJudge)[index]];

export const fetchChiefJudgeReport = (competition, report = 'chiefJudge') => dispatch =>
    axios(apiRequestOptions(pathOf(report, 0), null, { params: { competition } }))
        .then(transformHttpResponse)
        .then(response => (response.data || {}).fields || [])
        .catch(error => transformHttpResponse(error.response))
        .catch(error => {
            dispatch(errorRequestHandler(error));
            return null;
        });

export const saveChiefJudgeReport = (competition, values, report = 'chiefJudge') => dispatch =>
    axios(apiRequestOptions(pathOf(report, 1), { values }, { params: { competition } }))
        .then(transformHttpResponse)
        .then(response => (response.data || {}).fields || [])
        .catch(error => transformHttpResponse(error.response))
        .catch(error => {
            dispatch(errorRequestHandler(error));
            return null;
        });

/** The report as a Word document, with whatever was saved last. */
export const downloadChiefJudgeReport = (competition, report = 'chiefJudge') => dispatch =>
    axios(apiRequestOptions(pathOf(report, 2), null, {
        params: { competition },
        isBlob: true,
    }))
        .then(transformHttpResponse)
        .then(response => {
            const content = response.headers['content-type'];
            const contentDisposition = response.headers['content-disposition'] || '';
            const filenameMatch = contentDisposition.match(/filename="?([^";\s]+)"?/);
            download(response.data, filenameMatch ? filenameMatch[1] : 'report.docx', content);
        })
        .catch(error => transformHttpResponse(error.response))
        .catch(error => {
            dispatch(errorRequestHandler(error));
        });
